const lightGreyBgColour = { backgroundColor: '#F5F5F5' };
export default lightGreyBgColour;
